var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 11A4 4 0 1 0 15 19A4 4 0 1 0 15 11Z","key":0}),React.createElement("path",{"d":"M19.999,3h-10C6.14,3,3,6.141,3,10.001v10C3,23.86,6.141,27,10.001,27h10C23.86,27,27,23.859,27,19.999v-10C27,6.14,23.859,3,19.999,3z M15,21c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S18.309,21,15,21z M22,9c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C23,8.552,22.552,9,22,9z","key":1})]);
}

Instagram.defaultProps = {"fill":"#000000","viewBox":"0 0 30 30","width":"30px","height":"30px"};

module.exports = Instagram;

Instagram.default = Instagram;
